import type ViewType from "../constants/ViewType";
import type { FeatureFlagT } from "../proctor/FeatureFlags";
import type { QualificationAttribute } from "../types/JobAttribute";

import {
  getAttributesAndViewType,
  getTaxonomyIdToJssdId,
  getIsMatchInsightsSectionEnabled,
} from "./InsightsComponentModel.utils";

export function getInsightsModel(
  featureFlags: FeatureFlagT,
  loggedIn: boolean,
  mceModel: component.oneGraphMatchComparison.OneGraphMatchComparison,
  jobSeekerSuidsToFactIds: platform.model.JobSeekerSuidToFactId[],
): {
  isEnabled: boolean;
  attributes: QualificationAttribute[];
  viewType: ViewType;
} {
  const { attributes, viewType } = getAttributesAndViewType({
    mceModel,
    taxonomyIdToJssdId: getTaxonomyIdToJssdId(jobSeekerSuidsToFactIds),
    featureFlags,
  });

  const hasRequirements = attributes.length > 0;

  const isEnabled = getIsMatchInsightsSectionEnabled({
    hasRequirements,
    loggedIn,
    featureFlags,
    viewType,
  });

  return {
    isEnabled,
    attributes,
    viewType,
  };
}
